import proj4 from 'proj4';
import 'proj4leaflet';
import { useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { convertFromLv95ToUserCoordinate, type CoordinateSystemPreference } from 'utils/coordinateSystemManager';

// Define the Swiss LV95 projection system
const swissLv95Proj =
  '+proj=somerc +lat_0=46.9524056 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs';

// Function to convert coordinates from WGS84 to Swiss LV95
const wgs84ToLv95 = (lng: number, lat: number) => {
  const lv95Coords = proj4('EPSG:4326', swissLv95Proj, [lng, lat]);
  return lv95Coords;
};

// Component to show a popup with the mouse position in Swiss LV95 coordinates
const defaultCoordinateSystem: CoordinateSystemPreference = {
  mode: 'lv95',
  centerX: 0,
  centerY: 0,
  centerZ: 0,
  alpha: 0,
};

const MousePositionPopup = ({ coordinateSystem = defaultCoordinateSystem }) => {
  // State to store the coordinates of the mouse in LV95
  const [mouseCoords, setMouseCoords] = useState([0, 0]);

  // Hook to handle map events
  useMapEvents({
    // Event handler for mouse movement on the map
    mousemove(e) {
      // Convert the mouse coordinates from WGS84 to LV95
      const lv95Coords = wgs84ToLv95(e.latlng.lng, e.latlng.lat);
      const displayCoords = convertFromLv95ToUserCoordinate({ x: lv95Coords[0], y: lv95Coords[1] }, coordinateSystem);
      setMouseCoords([displayCoords.x, displayCoords.y]);
    },
  });

  return (
    <div className="coordinates-info">
      {mouseCoords[0].toFixed(2)}, {mouseCoords[1].toFixed(2)}
    </div>
  );
};

export default MousePositionPopup;
